import type { FlowIdBrandSymbol, StepIdBrandSymbol, StepProgressFlowConfig, StepProgressFlowStep, StepProgressIndicatorStep } from './step-progress.types';

import { createBrander } from '@hunting-nature/shared-core/utils/create-brander';

export const createStepId = createBrander<string, typeof StepIdBrandSymbol>();
export const createFlowId = createBrander<string, typeof FlowIdBrandSymbol>();

/**
 * Builds the full Angular route path for a given step.
 * Route is constructed as: baseRoute/stepId
 */
export const getFullRoutePath = (config: StepProgressFlowConfig, step: StepProgressFlowStep): string => {
  const baseRoute = config.baseRoute.endsWith('/') ? config.baseRoute.slice(0, -1) : config.baseRoute;
  const stepId = (step.id as string).startsWith('/') ? (step.id as string).slice(1) : (step.id as string);
  return `${baseRoute}/${stepId}`;
};

/**
 * Finds a step by its position number.
 */
export const getStepByPosition = (config: StepProgressFlowConfig, position: number): StepProgressFlowStep | undefined => {
  return config.steps.find(step => step.position === position);
};

/**
 * Extracts the current step position from the URL.
 */
export const getPositionFromUrl = (config: StepProgressFlowConfig, url: string): number => {
  const normalizedUrl = url.split('?')[0].split('#')[0];

  for (const step of config.steps) {
    const stepIdString = step.id as string;
    if (normalizedUrl.endsWith(`/${stepIdString}`)) {
      return step.position;
    }
  }

  return 1; // Fallback to first step
};

export const getVisibleSteps = (config: StepProgressFlowConfig): number => {
  return config.steps.filter(step => step.showInProgress !== false).length;
};

export const generateProgressSteps = (config: StepProgressFlowConfig, currentPosition: number): ReadonlyArray<StepProgressIndicatorStep> => {
  return config.steps
    .filter(step => step.showInProgress !== false)
    .map(step => ({
      position: step.position,
      isActive: step.position === currentPosition,
      isCompleted: step.position < currentPosition,
    }));
};
